<template>
  <section :class="['section-block', cssClasses]">
    <div v-if="header" class="section-block__top">
      <h2 class="section-block__header">
        {{ header }}
      </h2>

      <div v-if="isTopRightPopulated" class="section-block__top-right">
        <slot name="top-right"></slot>
      </div>
    </div>

    <slot></slot>
  </section>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: ''
    }
  },
  computed: {
    isTopRightPopulated() {
      return this.$slots['top-right'] !== undefined
    }
  }
}
</script>

<style lang="scss">
.section-block {
  @include container;
}

.section-block--no-padding-container {
  @include container(false);
}

.section-block--no-padding {
  padding: 0;
}

.wrapper--startpage .main > .section-block--no-padding {
  padding-right: measure(container-distance);
  padding-left: measure(container-distance);
}

.section-block--create-space {
  margin-bottom: measure(double);
}

.section-block--create-space-top {
  margin-top: measure(double);
}

.accordion-tabs--search .section-block--create-space-top {
  margin-top: measure(half);
}

.section-block__top {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding-bottom: measure(half);

  @include media(small) {
  }

  @include media(medium) {
    flex-direction: row;
    align-items: center;

  }
}

.section-block--no-padding-header .section-block__top {
  padding-top: 0;
}

.vehicle-brand-models .section-block__top {
  flex-direction: column;
  align-items: flex-start;
}

.section-block__header {
  @include h2-bold;
  order: 2;
  display: flex;
  flex-direction: column;
  margin: 0 0 measure(quarter) 0;

  @include media(medium) {
    flex-direction: row;
    align-items: center;
    order: 1;
    margin: 0;
  }
}

.section-block__link {
  @include body-bold;
  @include link;
  color: color(text-blue);
}

.section-block__top-right {
  display: flex;
  align-items: center;
  order: 1;
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-left: auto;
  }

  @include media(medium) {
    order: 2;
    margin-bottom: 0;
  }
}

.vehicle-brand-models .section-block__top-right {
  margin-top: measure(half);
  margin-left: 0;
}

.section-block__top-filter-text {
  margin-right: measure(full);
  white-space: nowrap;
}

.section-block__bottom {
  padding: measure(half) 0;
}
</style>
